<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Tenants
        <div class="page__header-subtitle">Your existing tenants</div>
      </div>
      <div class="page__header-tools">
        <div class="row justify-content-end pr-5">
          <button
            @click="addTenant"
            class="btn btn-success btn-sm"
            type="submit"
          >
            Add Tenant
          </button>
        </div>
      </div>
    </div>
    <div class="page__body">
      <div v-if="tenants" class="">
        <ef-table
          small
          striped
          hover
          table-class="customtable"
          thead-class="customtable__header"
          tbody-tr-class="customtable__tr"
          :confirm-message="'Are you sure you want to delete this tenant permanently?'"
          :items="tenants"
          :busy="loading"
          :fields="fields"
          :actions="['edit', 'delete']"
          @delete="deleteTenant"
          @edit="editTenant"
        >
        </ef-table>
      </div>
      <loader v-else></loader>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import toast from "./../toaster";
import EfTable from "./../components/EfTable";
import toaster from "./../toaster";
import noData from "../components/NoDataAvailable";
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers("admin/tenants");
export default {
  components: { EfTable, noData },
  methods: {
    ...mapActions(["loadTenants", "removeTenant"]),
    ...mapMutations(["stopLoading"]),
    addTenant() {
      this.$router.push("/admin/super-admin/tenants/add");
    },
    async deleteTenant(data) {
      this.removeTenant(data)
        .then((result) => {
          toaster.showToasts(this, "Tenant removed successfully.", "success");
        })
        .catch((err) => {
          this.stopLoading();
          toaster.showToasts(
            this,
            "There was an error while removing the teanant.",
            "danger"
          );
        });
    },
    editTenant({ data }) {
      this.$router.push("/admin/super-admin/tenants/edit?id=" + data.id);
    },
  },
  computed: {
    ...mapGetters({
      tenants: "tenantList/getAll",
    }),
    ...mapState(["loading"]),
  },
  mounted() {
    this.loadTenants()
      .then((result) => {})
      .catch((err) => {
        this.stopLoading();
        toaster.showToasts(
          this,
          "There was an error while getting the tenants list.",
          "danger"
        );
      });
  },
  data() {
    return {
      fields: [
        { key: "name" },
        { key: "organization" },
        { key: "domain" },
        { key: "Actions" },
      ],
    };
  },
};
</script>

<style lang="scss">
.customtable__icon {
  font-size: 12px;
}

.customtable__button-edit {
  color: orange;
  padding-right: 10%;
}
</style>